export const langChangeConsent = {
	0:{
		key:'We have undertaken initiatives to translate the UMANG mobile app/web into 23 regional, national, and international languages. Should you have any suggestions or information to contribute in this regard, kindly reach out to our customer support center. The English version of the language serves as the source/original form.'
	},
	1:{
		key:'उमंग मोबाइल एप/वेब को २३ क्षेत्रीय/राष्ट्रीय/अंतरराष्ट्रीय भाषाओं में अनुवाद का प्रयास किया गया है, यदि आप इस सन्दर्भ मे कोई सुझाव या सूचना देना चाहते है तो कृपया हमारे ग्राहक सहायता केंद्र मे संपर्क करे। भाषा का अंग्रेज़ी संस्करण ही मौलिक रूप है।'
	}
}
